const config = require('./store-locator-config');
const countryWoosmapVersion = tc_vars.env_country === 'CN' ? '1.4' : '1.3';

module.exports = function() {
  WoosmapLoader.load({
    callback: initFunction,
    publicKey: config.projectKey,
    loadJQuery: true,
    version: countryWoosmapVersion,
  });
};

var initFunction = function() {
  const loader = new woosmap.MapsLoader(config.googleConfig);
  const dataSource = new woosmap.DataSource();

  const state = {
    map: null,
    mapView: null,
    tableview: null,
    originDestinationInput: null,
  };

  loader.load(() => {
    if (window.tc_vars.env_country === 'CN') {
      // Woosmap CN by Baidu map
      require('./store-locator-china').init();
    } else {
      // Woosmap map V2
      require('./store-locator-woosmap').init(state, dataSource);

      //   // state.map & state.mapView are mutables and will be modified in store-locator-map module
      //   // in order to get a functionnal map/mapView to use in store-locator-directions
      // itinerary woosmap
      require('./store-locator-directions').init(state, dataSource);
    }
  });
};



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator.js